import { getIsApiPending, getQuoteForm } from '../../../selectors/travelSs/quote';
import {
    apiTransitionTravelInsuranceQuoteForm,
    calculateTravelInsurancePremiumSuccess,
    triggerGetUsdRate,
} from '../../../actions/travelSs/quote';
import { getAccessToken } from '../../../selectors/travelSs/payments';
import axios from 'axios';

export const premiumCalculationService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionTravelInsuranceQuoteForm.pending());
            store.dispatch(calculateTravelInsurancePremiumSuccess(null));
            try {
                const resp = await calculate(store.getState());

                store.dispatch(calculateTravelInsurancePremiumSuccess(resp.data));
                store.dispatch(apiTransitionTravelInsuranceQuoteForm.success());

                store.dispatch(triggerGetUsdRate());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionTravelInsuranceQuoteForm.failure());
            }
        }
    })();
    return next(action);
};

function convertDateFormat(dateString) {
    if (dateString) {
        const [day, month, year] = dateString.split('/');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }

    return '-';
}

const getNumberOfChildren = (quotation) => {
    if (quotation.selectedCover.value === 'Senior') {
        return 0;
    }

    return quotation.noOfMinors.value ? parseInt(quotation.noOfMinors.value) : 0;
};

const determineComposition = (quotation) => {
    const adultTravellers = parseInt(quotation.noOfTravellers?.value) || 0;
    const minorTravellers = parseInt(quotation.noOfMinors?.value) || 0;
    const totalNoOfTravellers = adultTravellers + minorTravellers;

    if (totalNoOfTravellers > 1) {
        return 'group';
    }

    return 'single';
};

const determineAxaDestinationArea = (quotation) => {
    if (quotation.selectedCover.value === 'Schengen') {
        return 'Schengen Area';
    }

    if (quotation.selectedCover.value === 'East Africa') {
        return 'East African country';
    }

    if (quotation.selectedCover.value === 'Holiday') {
        return 'Holiday';
    }

    return 'Senior';
};

const premiumCalculationPayload = (state) => {
    const quotation = getQuoteForm(state);

    const premiumCalculationPayload = {
        destination_area: determineAxaDestinationArea(quotation),
        start_date: convertDateFormat(quotation.departureDate.value),
        end_date: convertDateFormat(quotation.returnDate.value),
        composition: determineComposition(quotation),
        adult: quotation.selectedCover.value !== 'Senior' ? parseInt(quotation.noOfTravellers?.value) : 0,
        children: getNumberOfChildren(quotation),
        senior: quotation.selectedCover.value === 'Senior' ? parseInt(quotation.noOfTravellers?.value) : 0,
        oldest_traveler_age: parseInt(quotation.age.value),
        countryCode: 'SS',
    };

    return {
        ...premiumCalculationPayload,
    };
};

const calculate = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/travel-ss/compute-premium';

        return await axios.post(url, premiumCalculationPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
